import $ from 'jquery';

class ClaimFilter {

  constructor() {

  }

  setupEvents() {
    let _this = this;
    $('.claim-filter').find('.filter-type-date select.filter-operator').on('change', function() {
      let $filter = $(this).closest('.filter-type-date');
      _this.updateDateFilter($filter, $(this).val(), true);
    });

    $('#claim-filter-view-more').on('click', function(e) {
      e.preventDefault();
      let $el = $('.claim-filter-full');
      if ($el.is(':hidden')) {
        $(this).text('hide more...');
        $el.hide().removeClass('d-none').slideDown();
      }
      else {
        $(this).text('view more...');
        $el.slideUp();
      }
    });
  }

  updateDateFilter($filter, operator, clear) {
    let $daterange = $filter.find('.input-daterange');
    let $datestart = $daterange.find('.filter-date-start');
    let $dateend = $daterange.find('.filter-date-end');

    if (clear) {
      $datestart.val('');
      $dateend.val('');
    }

    if (operator == 'absolute') {
      $daterange.datepicker({
        orientation: 'left bottom'
      });
      $datestart.attr('placeholder', 'Start date');
      $dateend.attr('placeholder', 'End date');
    }
    else if (operator == 'relative') {
      $daterange.find('.filter-date-input').datepicker('destroy');
      $daterange.datepicker('remove');
      $datestart.attr('placeholder', 'Example: -30d (last 30 days)');
      $dateend.attr('placeholder', 'Example: 0d (today)');
    }
  }

  setupDateFilters() {
    let _this = this;

    $('.claim-filter').find('.filter-type-date').each(function() {
      let $filter = $(this);
      let operator = $filter.find('select.filter-operator').val();
      _this.updateDateFilter($filter, operator);
    })
  }

  load() {
    this.setupEvents();
    this.setupDateFilters();
  }
}

export default new ClaimFilter();
